/**
 * Bug #489
 * @Author Anupama P
 * @Date 9 Jul 2021
 */
import { Link, Nav, NavLink, Wrapper, Image } from 'components';
import IMG01 from '../../../assets/images/doctor-thumb-02.jpg';
import { MenuList } from './SideMenuList';
const DoctorSidebar = () => {
    return (
        <Wrapper className="profile-sidebar">
            <Wrapper className="widget-profile pro-widget-content">
                <Wrapper className="profile-info-widget">
                    <Wrapper className="media">
                        <Link to="#" className="booking-doc-img">
                            <Image src={IMG01} alt="User" roundedCircle />
                        </Link>
                        <Wrapper className="media-body ">

                            <Wrapper className="patient-details text-left pt-10 pl-2">
                                <h3>Dr. Darren Elder</h3>
                                <h5 className="mb-0">BDS, MDS - Oral & Maxillofacial Surgery</h5>
                            </Wrapper>
                        </Wrapper>
                    </Wrapper>

                </Wrapper>
            </Wrapper>
            <Wrapper className="dashboard-widget">


                <Nav className="dashboard-menu">
                    {MenuList.map((menu, index) =>
                        <Nav.Item key={index}>
                            <NavLink to={menu.to} activeClassName="active">
                                <i className={`fas ${menu.icon}`} />
                                <span>{menu.label}</span>
                                {menu.unreadCount !== 0 && <small className="unread-msg">{menu.unreadCount}</small>}
                            </NavLink>
                        </Nav.Item>
                    )}
                </Nav>


            </Wrapper>
        </Wrapper>
    );
}
export default DoctorSidebar;
